import { render, staticRenderFns } from "./CorrectionStatistics.vue?vue&type=template&id=067ddd4c&scoped=true&"
import script from "./CorrectionStatistics.vue?vue&type=script&lang=js&"
export * from "./CorrectionStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CorrectionStatistics.vue?vue&type=style&index=0&id=067ddd4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067ddd4c",
  null
  
)

export default component.exports